import { FC, useEffect, JSX } from 'react';
import {Route, Outlet, Navigate} from 'react-router-dom';
import {AuthenticationHandler} from "../../components/auth/AuthenticationHandler";
import {useContext} from "react";

const MemberRoute = () => {
    const auth = useContext(AuthenticationHandler);
    useEffect(() => {
    }, [auth]);
    return auth?.isAuthenticated ? <Outlet /> : <Navigate to="/login" />;

};

export default MemberRoute;
